import {
  FlexGrid,
  FlexGridColumn,
  FlexGridColumnGroup,
  FlexGridCellTemplate,
} from "@grapecity/wijmo.react.grid";
import { FlexGridFilter } from "@grapecity/wijmo.react.grid.filter";

const QubGroupGrid = (props) => {
  const { columns, gridData, initialized, cellTemplateColumns = [] } = props;

  return (
    <FlexGrid
      initialized={initialized}
      itemsSource={gridData}
      autoSizeMode={1}
      isReadOnly
      headersVisibility={3}
      alternatingRowStep={0}
      {...props}
      className="explorer-grid"
    >
      <FlexGridFilter />
      {columns.length > 0 &&
        columns.map((columnGroup, index) => (
          <FlexGridColumnGroup
            key={index}
            header={columnGroup?.grpDescr ?? ""}
            align="center"
          >
            {columnGroup?.children?.map((child) => (
              <FlexGridColumnGroup
                header={child?.fldTitle ?? ""}
                binding={child?.fldName ?? ""}
                visible={child?.isVisible}
                align="center"
              />
            ))}
          </FlexGridColumnGroup>
        ))}
    </FlexGrid>
  );
};

export default QubGroupGrid;
